import { RoleType } from '../../models/Role'
import { selectAccountId } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'
import { useGetBillingCustomerFreeSeatsQuery } from '../../store/plan/plan'
import { freeSeatsFor } from './requestedGroups'
import { useSeatPurchaseGate } from './seatPurchaseGate'
import { seatShortage } from './useRequestedSeatsSnapshot'

export interface BuySeatsButtonState {
  canBuySeats: boolean
  disabled: boolean
}

export interface RequestedSeatCounts {
  advisor?: number
  assistant?: number
}

export const useBuySeatsButton = (requestedSeats: RequestedSeatCounts): BuySeatsButtonState => {
  const accountId = useAppSelector(selectAccountId)
  const canBuySeats = useSeatPurchaseGate()
  const requestedTotal = (requestedSeats.advisor ?? 0) + (requestedSeats.assistant ?? 0)
  const { data: freeSeatsData } = useGetBillingCustomerFreeSeatsQuery({ accountId }, { skip: !canBuySeats || requestedTotal === 0 })

  const seats = freeSeatsData?.data.seats
  const shortage =
    (seatShortage(requestedSeats.advisor ?? 0, freeSeatsFor(RoleType.SEAT, seats)) ?? 0) +
    (seatShortage(requestedSeats.assistant ?? 0, freeSeatsFor(RoleType.SIDECAR, seats)) ?? 0)

  return { canBuySeats, disabled: shortage === 0 }
}
